export const chart_axis_tick_Fill = {
  "name": "--pf-v5-chart-axis--tick--Fill",
  "value": "transparent",
  "var": "var(--pf-v5-chart-axis--tick--Fill, transparent)"
};
export default chart_axis_tick_Fill;